let pipelineCols = [
    {
        key: 'id',
        display: 'Id'
    },
    {
        key: 'label',
        display: 'Label'
    },
    {
        key: 'pipelineTypeId',
        display: 'Pipeline Type Id'
    },
    {
        key: 'pipelineTypeLabel',
        display: 'Pipeline Type Label'
    },
    {
        key: 'enabled',
        display: 'Enabled'
    }
]

let resellerPipelineCols = [
    {
        key: 'resellerId',
        display: 'Reseller Id'
    },
    {
        key: 'resellerName',
        display: 'Reseller Name'
    },
    {
        key: 'productId',
        display: 'Product Id'
    },
    {
        key: 'productName',
        display: 'Product Name'
    },
    {
        key: 'deviceTypeId',
        display: 'Device Type Id'
    },
    {
        key: 'deviceTypeLabel',
        display: 'Device Type Label'
    },
    {
        key: 'deviceMakeId',
        display: 'Device Make Id'
    },
    {
        key: 'deviceMakeLabel',
        display: 'Device Make Label'
    },
    {
        key: 'incidentTypeId',
        display: 'Incident Type Id'
    },
    {
        key: 'incidentTypeLabel',
        display: 'Incident Type Label'
    },
    {
        key: 'pipelineId',
        display: 'Pipeline Id'
    },
    {
        key: 'pipelineLabel',
        display: 'Pipeline Label'
    },
    {
        key: 'pipelineTypeId',
        display: 'Pipeline Type Id'
    },
    {
        key: 'pipelineTypeLabel',
        display: 'Pipeline Type Label'
    },
    {
        key: 'enabled',
        display: 'Enabled'
    }
]

let piplineRuleCols = [
    {
        key: 'pipelineId',
        display: 'Pipeline Id'
    },
    {
        key: 'pipelineLabel',
        display: 'Pipeline Label'
    },
    {
        key: 'ruleId',
        display: 'Rule Id'
    },
    {
        key: 'ruleLabel',
        display: 'Rule Label'
    },
    {
        key: 'runOrder',
        display: 'Run Order'
    },
    {
        key: 'enabled',
        display: 'Enabled'
    }
]

let pipelineParamCols = [
    {
        key: 'id',
        display: 'Id'
    },
    {
        key: 'resellerPipelineId',
        display: 'Reseller Pipeline Id'
    },
    {
        key: 'pipelineRuleId',
        display: 'Pipeline Rule Id'
    },
    {
        key: 'ruleId',
        display: 'Rule Id'
    },
    {
        key: 'key',
        display: 'Key'
    },
    {
        key: 'value',
        display: 'Value'
    }
]

let ruleComponentCols = [
    {
        key: 'id',
        display: 'Id'
    },
    {
        key: 'label',
        display: 'Label'
    },
    {
        key: 'component',
        display: 'Component'
    },
    {
        key: 'enabled',
        display: 'Enabled'
    }
]

export { pipelineCols, resellerPipelineCols, piplineRuleCols, pipelineParamCols, ruleComponentCols }